import { changeCreds } from '../auth';
import axios from 'axios';

const checkAccessToken = async (tokenExp, token, refreshToken, store) => {
  // console.log(new Date(tokenExp))
  try {
    if (Number(tokenExp) < Date.now()) {
      const env = process.env.REACT_APP_ENVIRONMENT;
      let baseURL = env == 'production' ? 'https://advancedair-api.intelisys.ca/RESTv1' : 'https://advancedair-api.intelisystraining.ca/RESTv1'
      let url = '/userSessions'
      let method = 'put'
      let response = await axios.request({
        baseURL,
        url,
        method,
        data: {accessToken: token, refreshToken: refreshToken}
      })
      await store.dispatch(changeCreds(response.data))
      return response.data.accessToken
    }
  } catch (err) {
    console.log(`check access token failure :: ${err.message}`)
  }
};

export default checkAccessToken;